export default "__VITE_ASSET__B$hHwbDY__"